import styled from 'styled-components';
import { Container, StyledButton } from '@tryhackme/thm-ui-components';

export const StyledCertificate = styled(Container)`
  display: grid;
  grid-template-columns: minmax(50%, 60%) minmax(45rem, 1fr);
  gap: 2.4rem;
  margin: 2.4rem auto 3.2rem;
  align-items: start;

  h2 {
    margin-bottom: 0;
  }

  section {
    border-radius: ${({ theme }) => theme.radius.small};
    background-color: ${({ theme }) => theme.colors.background.main};
    color: ${({ theme }) => theme.colors.text.main};

    &[data-box='certificate'] {
      h2 {
        padding: 2.4rem;
      }
    }

    &[data-box='content'] {
      padding: 2.4rem;
    }
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1fr;
  }
`;

export const StyledHeader = styled.header`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.6rem;
`;

export const StyledDownloadButton = styled(StyledButton)`
  padding: 0.85rem 0.9rem;

  svg {
    width: 1.6rem;
    height: 1.9rem;
  }
`;

export const StyledRoomTitle = styled.h3`
  color: ${({ theme }) => theme.colors.success.main};
  font-size: 2rem;
`;

export const StyledContentSection = styled.div`
  margin: 2.4rem 0;

  h3 {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
  }

  ul {
    list-style-type: disc;
    padding-left: 2rem;
    margin-top: 0.8rem;
  }

  li,
  p {
    margin-bottom: 0.8rem;
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    text-align: left;
  }

  li {
    ::marker {
      color: ${({ theme }) => theme.colors.success.main};
      font-size: ${({ theme }) => theme.fonts.sizes.default};
    }
  }

  &[data-section='flex'] {
    display: flex;
    justify-content: flex-start;
    gap: 0.8rem;
    margin: 2.4rem 0 0;
  }

  div {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
  }
`;

export const StyledRecordItem = styled.span`
  align-items: center;
  background: ${({ theme }) => theme.colors.background.dark};
  border-radius: 10rem;
  display: flex;
  font-size: ${({ theme }) => theme.fonts.sizes.medium};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  gap: 1rem;
  padding: 1rem 1.6rem;

  svg {
    height: 1.8rem;
    width: 1.8rem;
    color: ${({ theme }) => theme.colors.grey[500]};
  }
`;

export const StyledImageWrapper = styled.figure`
  width: 100%;
  height: auto;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;
